import { flow, get, map, curry } from 'lodash/fp';

export default curry((category, windowCategoryMappings) => flow(
  get(`${category}.productCategories`),
  map(cat => encodeURIComponent(cat).replace(/%20/g, '+')),
  mappings => ({ category: mappings }),
  params => JSON.stringify(params).replace(':', ': '),
)(windowCategoryMappings));
